export const renderTooltip = ({
  label,
  value,
  color,
}: {
  label: string;
  value: number | string;
  color?: string;
}) => {
  return `
    <div style="display: flex; align-items: center; gap: 4px; width: 100%;">
    ${
      color
        ? `<div style="background:${color}; border-radius: 50%; width: 12px; height: 12px;"></div>`
        : ''
    }

        ${label}

        ${value} 
    </div>
    `;
};
